<template>
  <b-container v-if="this.$root.token" class="pt-2">
    <b-container class="pt-0 pb-0 " v-if="session">
      <survey-run-selection :no-new="true" :required="true" :survey-run-id="session.survey_run_id" @update:surveyRun="surveyRun = $event.surveyRun"/>
      <g-p-c-session-selection :customer="surveyRun.customer.id" v-model="gpcSession" :gpc-id="session.gpc_id" :required="false" v-if="surveyRun && surveyRun.id"/>
      <b-row v-if="surveyRun && surveyRun.id" class="text-left">
        <b-col>
          <b-form-group 
            id="statusgroup"
            breakpoint="md"
            label="Status"
            label-for="status"
            validated
          >
            <b-form-select v-model="session.status" class="mb-3" :options="['Draft', 'Sent', 'Completed']"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-left" v-if="session.status === 'Sent' || session.status === 'Completed'">
        <b-col>
          <b-form-group 
            id="datesentgroup"
            breakpoint="md"
            label="Date Sent to Customer"
            label-for="datesent"
            validated
          >
            <datepicker v-model="session.date_sent" id="datesent" :disabled-dates="{'from': new Date()}"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-left" v-if="session.status === 'Completed'">
        <b-col>
          <b-form-group 
            id="datecompletedgroup"
            breakpoint="md"
            label="Date Completed"
            label-for="datecompleted"
            validated
          >
            <datepicker v-model="session.date_completed" id="datecompleted" :disabled-dates="{'from': new Date()}"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-left" v-if="surveyRun && surveyRun.id">
        <b-col>
          <b-form-group 
            id="problem_owner_group"
            breakpoint="md"
            label="Problem Owner"
            label-for="problem_owner"
            validated
          >
            <b-form-input v-model="session.problem_owner" required id="problem_owner"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-left" v-if="session.problem_owner">
        <b-col>
          <b-form-group 
            id="problem_group"
            breakpoint="md"
            label="Problem"
            label-for="problem"
            validated
          >
            <wysiwyg v-model="session.problem" id="problem" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-left" v-if="session.problem">
        <b-col>
          <b-form-group 
            id="action_group"
            breakpoint="md"
            label="Action(s)"
            label-for="action"
            validated
          >
            <wysiwyg v-model="session.actions" id="action" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-left">
        <b-col>
          S.M.A.R.T. Goal(s):
        </b-col>
      </b-row>
      <b-row class="pb-3">
        <div ref="goals" class="container"/>
      </b-row>
      <b-row class="text-right pb-3">
        <b-col>
          <b-button variant="primary" @click="addGoal()" >Add another S.M.A.R.T. Goal</b-button>
        </b-col>
      </b-row>
      <b-row v-if="saving" class="text-center">
        <font-awesome-icon icon="spinner" size="lg" spin/>
      </b-row>
      <b-alert :show="!!message" variant="success" ref="gpcInputMessage" >{{ message }}</b-alert>
      <b-row class="pb-5" v-if="!saving">
        <b-col>
          <b-button variant="success" @click="save()" :disabled="!formCompleted">Save</b-button>
        </b-col>
        <b-col v-if="!!message" >
          <b-button variant="primary" @click="clearForm()">Add another</b-button>
        </b-col>
        <b-col>
          <b-button variant="default" @click="clearForm()">Clear Form</b-button>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>
<script>
// @ is an alias to /src
import Datepicker from 'vuejs-datepicker';
import Vue from 'vue';
import Goal from '@/components/Goal.vue';
import SurveyRunSelection from '@/components/SurveyRunSelection.vue';
import GPCSessionSelection from '@/components/GPCSessionSelection.vue';
import * as API from '@/services/API';

export default {
  name: "SmartGoalAddEdit",
  components: {
    Datepicker,
    SurveyRunSelection,
    GPCSessionSelection
  },
  props: {
    sessionToEdit: {
      type: Object,
      default: function () {
        return {
          id: null,
          survey_run_id: null,
          gpc_id: null,
          status: 'Draft',
          date_sent: null,
          date_completed: null,
          problem_owner: null,
          problem: null,
          actions: null,
          smartGoals: []
        };
      }
    }
  },
  watch: {
    sessionToEdit: function(newVal) {
      console.log(this);
      console.log('changing session to edit');
      this.init();
    },
    surveyRun: function(newVal) {
      if (newVal) this.session.survey_run_id = newVal.id;
    },
    gpcSession: function(newVal) {
      if (newVal) {
        this.session.gpc_id = newVal.id;
        if (!this.session.problem_owner) this.session.problem_owner = newVal.responsible_name;
        if (!this.session.problem) this.session.problem = newVal.problem;
        if (!this.actions) this.session.actions = newVal.actions;
      } 
    }
  },
  data: function() {
    return {
      saving: false,
      message: null,
      session: {},
      surveyRun: {},
      gpcSession: {},
      surveyRunId: null
    };
  },
  computed: {
    formCompleted: {
      get: function() {
        /**if (!this.gpcSession.customer_id) return false;if (!this.gpcSession.customer_id) return false;
        // check for nulls
        return Object.keys(this.gpcSession).reduce((accumulator, field) => {
          if (!accumulator || field === 'id') return accumulator;
          if (!this.gpcSession[field]) return false;
          return accumulator;
        }, true);*/
        return true;
      }
    }
  },
  created() {
    if (this.sessionToEdit.survey_run_id) this.session.survey_run_id = this.sessionToEdit.survey_run_id;
    if (this.sessionToEdit.gpc_id) this.session.gpc_id = this.sessionToEdit.gpc_id;
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      
      this.session = {
        id: this.sessionToEdit.id || null,
        survey_run_id: this.sessionToEdit.survey_run_id || null,
        gpc_id: this.sessionToEdit.gpc_id || null,
        status: this.sessionToEdit.status || 'Draft',
        date_sent: this.sessionToEdit.date_sent || null,
        date_completed: this.sessionToEdit.date_completed || null,
        problem_owner: this.sessionToEdit.problem_owner || null,
        problem: this.sessionToEdit.problem || null,
        actions: this.sessionToEdit.actions || null,
        smartGoals:  []
      };
      this.clearGoals();
      let hasGoals = false;
      if (this.sessionToEdit && this.sessionToEdit.smartGoals) {
        this.sessionToEdit.smartGoals.forEach(goal => {
          if (!goal.is_deleted) hasGoals = true;
          this.addGoal(goal);
        });
      }
      if (!hasGoals) this.addGoal();
      this.message = '';
    },
    clearForm() {
      this.session = {
        id: this.sessionToEdit.id || null,
        survey_run_id: this.sessionToEdit.survey_run_id || null,
        gpc_id: this.sessionToEdit.gpc_id || null,
        status: this.sessionToEdit.status || 'Draft',
        date_sent: this.sessionToEdit.date_sent || null,
        date_completed: this.sessionToEdit.date_completed || null,
        problem_owner: this.sessionToEdit.problem_owner || null,
        problem: this.sessionToEdit.problem || null,
        actions: this.sessionToEdit.actions || null,
        smartGoals:  []
      };
      this.surveyRun = {};
      this.gpcSession = {};
      this.clearGoals();
      let hasGoals = false;
      if (this.sessionToEdit && this.sessionToEdit.smartGoals) {
        this.sessionToEdit.smartGoals.forEach(goal => {
          if (!goal.is_deleted) hasGoals = true;
          this.addGoal(goal);
        });
      }
      if (!hasGoals) this.addGoal();
      this.message = '';
    },
    save() { 
      this.saving = true;
      this.message = 'Saving....';
      // do actual search
      const body = JSON.parse(JSON.stringify(this.session));
      delete body.survey_run_id;
      delete body.id;
      Object.keys(body).forEach(key => {
        if (!body[key]) delete body[key];
      });

      const isNew = !this.session.id;

      API.saveGoalSetting(this.session.survey_run_id, this.session.id, body, this.$root.token).then(results => {
        this.$emit('update-sessions', results.body);
        this.saving = false;
        this.message = 'Saved!';
        if (isNew) this.clearForm();
      }).catch(e => {
        this.saving = false;
        this.message = 'DID NOT SAVE - CALL SUPPORT';
      });
      
    },
    addGoal(newGoal) {
      const toAdd = newGoal || ({
        s: '',
        m: '',
        a: '',
        r: '',
        t: '',
        is_deleted: 0
      });
      console.log(newGoal);
      this.session.smartGoals.push(toAdd);
      if (!toAdd.is_deleted) {
        const GoalClass = Vue.extend(Goal);
        const instance = new GoalClass({
          propsData: { goal: this.session.smartGoals[this.session.smartGoals.length - 1]}
        });
        instance.$mount();
        this.$refs.goals.appendChild(instance.$el);
      }
    },
    clearGoals() {
      while(this.$refs.goals.firstChild) this.$refs.goals.removeChild(this.$refs.goals.firstChild);
    }
  }
}
</script>
<style>
.buttonbar {
  padding-top: 4em;
  padding-bottom: 4em;
}
</style>



// WEBPACK FOOTER //
// src/components/SmartGoalAddEdit.vue